"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnalyticsService = void 0;
var _analytics = require("../controllers/analytics.controller");
var AnalyticsService = {
  analytics: {
    activityLog: _analytics.config.analytics + "/activity-log",
    snapshot: _analytics.config.analytics + "/snapshot",
    snapshotList: _analytics.config.analytics + "/snapshot/list",
    session: _analytics.config.analytics + "/session",
    systemMetrics: _analytics.config.analytics + "/system-metrics",
    export: _analytics.config.analytics + "/export",
    fetchRecordScore: _analytics.config.analytics + "/record/score"
  },
  analyticsSite: {
    system: _analytics.config.analyticsSite + "/system",
    filter: _analytics.config.analyticsSite + "/filter"
  },
  analyticsReport: {
    system: _analytics.config.analyticsReport + "/system",
    filter: _analytics.config.analyticsReport + "/filter"
  },
  dataAndAlertSite: {
    recentActivitySites: _analytics.config.dataAndAlertSite + "/recent-activity",
    notificationSite: _analytics.config.dataAndAlertSite + "/alert-notification",
    addNotificationSite: _analytics.config.dataAndAlertSite + "/alert-notification",
    updateNotificationSite: _analytics.config.dataAndAlertSite + "/alert-notification"
  },
  dataAndAlertReport: {
    addNotificationReport: _analytics.config.dataAndAlertReport + "/alert-notification",
    updateNotificationReport: _analytics.config.dataAndAlertReport + "/alert-notification",
    recentActivityReport: _analytics.config.dataAndAlertReport + "/recent-activity",
    notificationReport: _analytics.config.dataAndAlertReport + "/alert-notification"
  },
  siteDataAndAlert: {
    alertNotification: _analytics.config.siteDataAndAlert + "/alert-notification"
  },
  reportDataAndAlert: {
    alertNotification: _analytics.config.reportDataAndAlert + "/alert-notification"
  },
  snapshot: {
    fetch: _analytics.config.analyticsSnapshot,
    add: _analytics.config.analyticsSnapshot,
    delete: _analytics.config.analyticsSnapshot,
    list: _analytics.config.analyticsSnapshot + "/list",
    download: _analytics.config.analyticsSnapshot + "/download",
    downloadLive: _analytics.config.analyticsSnapshot + "/download/live/site",
    downloadLiveReport: _analytics.config.analyticsSnapshot + "/download/live/report"
  },
  analyticsSession: {
    addSite: _analytics.config.analyticsSession + "/site",
    addReport: _analytics.config.analyticsSession + "/report",
    delete: _analytics.config.analyticsSession,
    fetchRecording: _analytics.config.analyticsSession + "/recording",
    addInitialSessionForSite: _analytics.config.analyticsSession + "/site/initial",
    addInitialSessionForReport: _analytics.config.analyticsSession + "/report/initial"
  },
  analyticsSessionBulk: {
    bulkDelete: _analytics.config.analyticsSessionBulk + "/delete"
  },
  sessionAlertNotification: {
    sendNotification: _analytics.config.sessionAlertNotification + "/send-notification"
  },
  changeLog: {
    list: _analytics.config.changeLog + "/list",
    listPlatform: _analytics.config.changeLog + "/list/platform",
    changesPerformed: _analytics.config.changeLog + "/changes-performed",
    mediumList: _analytics.config.changeLog + "/medium/list",
    moduleList: _analytics.config.changeLog + "/module/list",
    componentList: _analytics.config.changeLog + "/component/list",
    actorList: _analytics.config.changeLog + "/actor/list",
    downloadChangeLogVersionFile: _analytics.config.changeLog + "/version/download"
  }
};
exports.AnalyticsService = AnalyticsService;